import React, { useState } from 'react';
import { Tab, Box } from '@mui/material';
import { AbilitiesGroup, Prosody, RateAndAccuracy, ratingHooks, ReadingComprehension } from '.';
import { WrapTabs, Soon } from './Style'
import { dark } from 'styles/theme';
import { useTheme } from 'styles';
import { LightButton, ScrollBox } from 'styles/GlobalStyle';
import { thirdly2 } from 'styles/theme';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getAbilitiesGroupFetch } from 'store/middlewares/assessment.crud';
import { categories, queryClient as qc } from 'keys';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const TabComponent = (props) => {
    const { index, value, tab, data } = props

    const { Layout } = useTheme()

    return (
        <ScrollBox
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{ ...Layout.grow }}
        >
            {value === index &&
                <Box>
                    <props.component {...tab} data={data} />
                </Box>
            }
        </ScrollBox>
    )
}

const ChallengesTabs = (props) => {
    const { ability_groups, category } = props
    const { assessment } = useSelector(state => state.assessment)
    const { rating } = useSelector(state => state.rating)
    const { total_count, correct_count } = rating || {}

    const isQuestions = assessment.reading_assessment_category_name == categories.MULTIPLE_CHOICE_QUESTIONS

    const { state } = useLocation()
    const isPassage = state?.isPassage || false;
    // למבדקים שהגיעו ממבדק שאלון והופנו למבדק האם, נכנסים ישר לטאב של הבנת הנקרא
    const [value, setValue] = useState(!isPassage ? 0 : 1);

    const { Layout, Fonts } = useTheme()

    const { title } = ratingHooks.constants

    const abilitiesGroupOptions = queryOptions({
        queryKey: [qc.abilitiesGroup, value],
        queryFn: async () => {
            const params = {
                //אנחנו מפחיתים 1 בגלל הטאב הראשון הקבוע
                group: ability_groups[value - 1].id,
                category: category
            }
            const { data } = await getAbilitiesGroupFetch({ params })
            return data
        },
    })
    const abilitiesGroup = useQuery(abilitiesGroupOptions)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ ...Layout.fullWidth, color: dark, ...Layout.grow, ...Layout.scroll, ...Layout.col }}>
            <div style={{ ...Layout.rowHCenter }}>
                <div style={{ width: '100px', ...Layout.shrink, ...Fonts.textSmall }}>{title}</div>
                <Box sx={{ ...Layout.grow, borderBottom: 1, borderColor: thirdly2, ...Layout.rowHCenter, ...Layout.justifyContentBetween, ...Layout.shrink, height: 45 }}>
                    <WrapTabs
                        value={value}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: dark,
                                fontWeight: 'bold'
                            }
                        }}
                        onChange={handleChange}
                        aria-label="basic tabs example">
                        {isQuestions ||
                            <Tab label={"שטף"} />}
                        {total_count &&
                            <Tab label={"הבנת הנקרא"} />}
                        {/* // } */}

                        {/* {assessment.prosody &&
                            <Tab label={"הבנת הנקרא"} />} */}
                        {/* {ability_groups?.map((tab, index) =>
                            <Tab
                                disabled={tab.disabled}
                                label={tab.label}
                                id={`simple-tab-${index}`}
                                aria-controls={`simple-tabpanel-${index}`}
                            />
                        )} */}
                    </WrapTabs>
                </Box>
            </div>
            {isQuestions ||
                <TabComponent
                    value={value}
                    index={0}
                    component={RateAndAccuracy}
                />}
            <TabComponent
                value={value}
                index={1}
                component={ReadingComprehension}
            />
            {/* <TabComponent
                value={value}
                index={1}
                component={Prosody}
            /> */}
            {ability_groups?.map((tab, index) =>
                <TabComponent
                    value={value}
                    index={index + 2}//there is two const tabs so we start with 2 index
                    tab={tab}
                    component={AbilitiesGroup}
                    data={abilitiesGroup.data}
                />
            )}
        </Box>
    );
}

export default ChallengesTabs
